import { Earth, Globe } from 'lucide-react';
import BrazilFlag from './BrazilFlag';

/**
 * Ícone do mercado do bot: bandeira do Brasil (BRL), globo (Global/USD) ou a
 * Terra pelas Américas (LATAM).
 * Use no lugar dos emojis 🇧🇷/🌎 — emoji de bandeira não renderiza no Windows.
 */
export default function MarketIcon({ mode, size = 14 }) {
    if (mode === 'usd') return <Globe size={size} className="text-blue-300 shrink-0" aria-hidden="true" />;
    if (mode === 'mxn') return <Earth size={size} className="text-teal-300 shrink-0" aria-hidden="true" />;
    return <BrazilFlag width={size + 2} className="shrink-0" />;
}
